import { Button, CircularProgress } from '@mui/material';
import {
  oneTimePaymentButtonSx,
  saveForLaterButtonSx
} from '../styles/createCampaign';

// Types
export interface CampaignActionsProps {
  primaryActionText: string;
  secondaryActionText: string;
  onOneTimePayment?: () => void;
  onSaveForLater?: () => void;
  isLoading?: boolean;
  secondaryActionLoading?: boolean;
  primaryActionDisabled?: boolean;
}

// Component
export const CampaignActions = ({
  primaryActionText,
  secondaryActionText,
  onOneTimePayment,
  onSaveForLater,
  isLoading = false,
  secondaryActionLoading = false,
  primaryActionDisabled = false
}: CampaignActionsProps) => {
  return [
    <Button
      key="one-time-payment"
      variant="contained"
      sx={oneTimePaymentButtonSx}
      onClick={onOneTimePayment}
      disabled={isLoading || primaryActionDisabled}
    >
      {isLoading ? (
        <CircularProgress color="inherit" size={24} />
      ) : (
        primaryActionText
      )}
    </Button>,
    <Button
      key="save-for-later"
      variant="outlined"
      sx={saveForLaterButtonSx}
      onClick={onSaveForLater}
      disabled={isLoading}
    >
      {secondaryActionLoading ? (
        <CircularProgress color="inherit" size={24} />
      ) : (
        secondaryActionText
      )}
    </Button>
  ];
};

